export enum CellFormats {
  LeftAligned = '@',
  CurrencyInteger = '#,###',
  CurrencyDecimal = '#,##0.00',
  CurrencyDecimalWithDollar = '"$"#,##0.00',
  WithDecimalPart = '0.000',
  PrepandedWithSign = '+#0;-#0',
  Date = 'mm/dd/yy'
}